import { Card } from '@/shared/components/ui/card'
import { cn } from '@/shared/utils/cn'

function SkeletonBar({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-surface', className)} />
}

export function OrganizationSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <SkeletonBar className="h-16 w-16 rounded-card" />
        <div className="flex-1 space-y-2">
          <SkeletonBar className="h-7 w-2/3" />
          <SkeletonBar className="h-4 w-1/3" />
        </div>
      </div>
      <Card>
        <SkeletonBar className="mb-4 h-5 w-1/4" />
        <div className="grid gap-4 sm:grid-cols-2">
          <SkeletonBar className="h-12" />
          <SkeletonBar className="h-12" />
          <SkeletonBar className="h-12" />
          <SkeletonBar className="h-12" />
        </div>
      </Card>
      <Card>
        <SkeletonBar className="mb-4 h-5 w-1/4" />
        <SkeletonBar className="h-10" />
      </Card>
    </div>
  )
}
